<template>
  <b-container class="mt-2">
    <div v-if="showScreener">
          
      <div class="d-none d-md-block">    
      <b-row class="progress-row">
        <b-col>
          <ul class="progressbar">
            <li v-bind:class="{ active: current_step >= i }" v-for="i in max_step" :key="i"><span class="sr-only">part {{i}} of 5</span>{{screenerContent.Steps[i-1]}}</li>
          </ul>
        </b-col>
      </b-row>
      </div>
 
       <div class="d-block d-md-none">
          <div :class="['mobile-step',(current_step == i ? 'active' : null), (current_step > i ? 'completed' : null)]" v-for="i in max_step" :key="i"><span class="sr-only">part {{i}} of 5</span>{{screenerContent.Steps[i-1]}}</div>
      </div>
 

      <b-card v-if="current_step == 1" class="card-style">
        <h2 class="card-title" tabindex="0">{{screenerContent.Contact.StepName}}</h2>
        <b-row align-v="start" class="text-left">
          <b-col>
            <p class="card-subtitle" tabindex="0">{{screenerContent.Contact.ContactIntro}}</p>
            <p tabindex="0" v-html="screenerContent.Contact.Disclaimer">
            </p>
          </b-col>
        </b-row>
        <b-form @submit="contactInfoSubmit">
          
          <b-form-group
            :label="screenerContent.Contact.Name + '*'"
            label-sr-only
            label-for="name"
          >
            <b-form-input
              id="name"
              v-model="name"
              :placeholder="screenerContent.Contact.Name + '*'"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            :label="screenerContent.Contact.Email + '*'"
            label-sr-only
            label-for="email"
          >
            <b-form-input
              id="email"
              v-model="email"
              :placeholder="screenerContent.Contact.Email + '*'"
              type="email"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            :label="screenerContent.Contact.Phone + '*'"
            label-sr-only
            label-for="phone"
          >
            <b-form-input
              id="phone"
              v-model="phone"
              :placeholder="screenerContent.Contact.Phone + '*'"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="accepted"
                unchecked-value="not_accepted"
                required><div v-html="screenerContent.Contact.Consent"></div></b-form-checkbox>
          </b-form-group>
          <b-button class="float-right" type="submit" pill variant="primary"
            >{{screenerContent.NextButton}}</b-button
          >
        </b-form>
      </b-card>
      <b-card
        v-if="current_step == 2"
        class="card-style"
      >
        <h2 class="card-title" tabindex="0">{{screenerContent.Birthday.StepName}}</h2>
        <b-row align-v="start" class="text-left">
          <b-col>
            <p class="card-subtitle" tabindex="0">{{screenerContent.Birthday.BirthdayIntro}}</p>
            <p tabindex="0">
              {{screenerContent.Birthday.BirthdayDescription}}
            </p>
          </b-col>
        </b-row>
        <b-form @submit="birthdaySubmit">
          <b-form-group
            :label="screenerContent.Birthday.Month + '*'"
            label-sr-only
          >
            <b-form-select
              v-model="birthdayMonth"
              :options="screenerContent.Birthday.Months"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group
            :label="screenerContent.Birthday.Day + '*'"
            label-sr-only
          >
            <b-form-select
              v-model="birthdayDay"
              :options="birthday_days"
              required
            ></b-form-select>
          </b-form-group>
          <b-form-group
            :label="screenerContent.Birthday.Year + '*'"
            label-sr-only
          >
            <b-form-select
              v-model="birthdayYear"
              required
            >
              <b-form-select-option :value="0">Year</b-form-select-option>
            <b-form-select-option v-for="year in birthday_years" :key="year" :value="year">{{year}}</b-form-select-option> 
            </b-form-select>
          </b-form-group>
          <p v-if="invalidBirthDate" class="error">
            {{screenerContent.Birthday.BirthdayError}}
          </p>
          <br />
          <b-button @click="onClickBack" class="float-left" pill variant="danger"
            >{{screenerContent.BackButton}}</b-button
          >
          <b-button class="float-right" type="submit" pill variant="primary"
            >{{screenerContent.NextButton}}</b-button
          >
        </b-form>
      </b-card>
      <b-card v-if="current_step == 3" class="card-style">
        <h2 class="card-title" tabindex="0">{{screenerContent.Address.StepName}}</h2>
        <b-row align-v="start" class="text-left">
          <b-col>
            <p class="card-subtitle" tabindex="0">{{screenerContent.Address.AddressIntro}}</p>
            <p tabindex="0" v-html="screenerContent.Address.AddressDescription">
            </p>
          </b-col>
        </b-row>
        <b-form-group
          :label="screenerContent.Address.StepName"
          label-for="map"
          label-sr-only
        >
          <vue-google-autocomplete
          ref="addressTo"
          id="map"
          classname="form-control"
          :placeholder="screenerContent.Address.StartTyping + '*'"
          v-on:placechanged="getAddressData"
          :rules="[rules.required]"
          :country="['us']"
          :enable-geolocation=true
          :value="getSavedAddress"
          style="margin-bottom:10px;"
          v-on:inputChange="addressInputChanged"
        >
        </vue-google-autocomplete>
        <p v-if="invalidAddress" class="error">
            {{screenerContent.Address.AddressError}}
          </p>
        </b-form-group>
        <b-form-group
          :label="screenerContent.Address.Apartment"
          label-for="apartment"
          label-sr-only
        >
          <b-form-input
            id="apartment"
            v-model="apartment"
            :placeholder="screenerContent.Address.Apartment"
            type="text"
          ></b-form-input>
        </b-form-group>
        <b-button @click="onClickBack" class="float-left" pill variant="danger"
          >{{screenerContent.BackButton}}</b-button
        >
        <b-button
          @click="addressSubmit"
          class="float-right"
          type="submit"
          pill
          variant="primary"
          >{{screenerContent.NextButton}}</b-button
        >
      </b-card>
      <b-card
        v-if="current_step == 4"
        class="card-style"
      >
        <h2 class="card-title" tabindex="0">{{screenerContent.Criteria.StepName}}</h2>
        <p class="card-subtitle pb-4" tabindex="0">{{screenerContent.Criteria.IntroText}}</p>
        <b-form @submit="specialCircumstancesSubmit">
          <div v-for="category in screenerContent.Criteria.Criteria" :key="category.Value">
            <b-form-group v-if="criteria.filter(x => x.Category == category.Value).length > 0"
            >
              <legend class="bv-no-focus-ring col-form-label pt-0">{{category.Label}} <button v-if="category.ShowHelpText" @click="openInfo('cat_' + category.Value)" @click.stop.prevent style="background:transparent;border:0px;"><span class="sr-only">Click for more info</span><b-icon icon="info-circle"></b-icon></button></legend>
              <div v-for="crit in criteria.filter(x => x.Category == category.Value)" :key="crit.value">
                <b-form-checkbox  v-model="selectedCriteria" :value="crit.value">
                  {{crit.text}}
                  <button v-if="crit.ShowHelpText" @click="openInfo('crit_' + crit.value)" @click.stop.prevent style="background:transparent;border:0px;">
                    <span class="sr-only">Click for more info</span><b-icon icon="info-circle" ></b-icon>
                  </button>
                </b-form-checkbox>
              </div>
            </b-form-group>
          </div>
          <b-button @click="onClickBack" class="float-left" pill variant="danger"
            >{{screenerContent.BackButton}}</b-button
          >
          <b-button class="float-right" type="submit" pill variant="primary"
            >{{screenerContent.NextButton}}</b-button
          >
          <b-modal v-model="showHelpText"
            hide-footer
            hide-backdrop
          >
          <div v-html="helpText"></div>
          </b-modal>
        </b-form>
      </b-card>
      <b-card
          v-if="current_step == 5"
          class="card-style text-left"
      >
          <h2 class="card-title" tabindex="0">{{screenerContent.Income.StepName}}</h2>
          <b-card-text>
              <p>{{screenerContent.Income.IncomeDescription}}</p>
          </b-card-text>
          <b-form @submit="incomeSubmit">
              <b-form-group
                :label="screenerContent.Income.Persons + '*'"
                label-for="peopleInHousehold"
              >
                  <b-form-select
                      id="peopleInHousehold"
                      v-model="peopleInHousehold"
                      :options="people_in_house_options"
                      required
                  >
                  </b-form-select>
              </b-form-group>
              <b-form-group
                :label="screenerContent.Income.Annual + '*'"
                label-for="annualIncome"
              >
                  <CurrencyInput id="annualIncome"  class="form-control" v-model="income" :options="currencyOptions" required></CurrencyInput>
              </b-form-group>
              <b-button @click="onClickBack" class="float-left" pill variant="danger"
              >{{screenerContent.BackButton}}</b-button
              >
              <b-button class="float-right" type="submit" pill variant="primary"
              >{{screenerContent.NextButton}}</b-button
              >
          </b-form>
      </b-card>
    </div>
    <div v-else>
     
      <section style="background:white;" class="programs-services py-2" v-if="anyEligible && !categoryView && !programView">
        
        <div v-if="programs.filter(x => !x.Ineligible).length > 0">
          <p class="large-text text-center" v-html="screenerContent.EligiblePrograms"></p>
          <p class="text-center" v-html="screenerContent.LearnMoreDescription"></p>
          <ProgramList :programs="programs.filter(x => !x.Ineligible)" :learnMoreText="screenerContent.LearnMoreButton"></ProgramList>
        </div>
      </section>
      <section style="background:white;" class="programs-services py-3" v-else-if="anyEligible && !programView && categoryView">
        <div v-if="programs.filter(x => !x.Ineligible && x.ProgramCategory == categoryView).length > 0">
          <p class="large-text text-center">{{screenerContent.CategoryEligible}} {{screenerContent.Categories.filter(x => x.CategoryName == categoryView)[0].TranslatedName}}</p>
          <div v-if="programs.filter(x => !x.Ineligible && x.ProgramCategory == categoryView).length > 0">
            <ProgramList :programs="programs.filter(x => !x.Ineligible && x.ProgramCategory == categoryView)" :learnMoreText="screenerContent.LearnMoreButton"></ProgramList>
          </div>
        </div>
        <div v-else>
          <p class="large-text text-center">{{screenerContent.CategoryNotEligible}} {{screenerContent.Categories.filter(x => x.CategoryName == categoryView)[0].TranslatedName}}</p>
        </div>
        <div v-if="programs.filter(x => !x.Ineligible && x.ProgramCategory != categoryView).length > 0">
          <div v-if="programs.filter(x => !x.Ineligible && x.ProgramCategory != categoryView).length > 0">
            <p class="large-text text-center" v-html="screenerContent.AlsoEligibleFor"></p>
            <p class="text-center" v-html="screenerContent.LearnMoreDescription"></p>
            <ProgramList :programs="programs.filter(x => !x.Ineligible && x.ProgramCategory != categoryView)" :learnMoreText="screenerContent.LearnMoreButton"></ProgramList>
          </div>
        </div>
      </section>
      <section style="background:white;" class="programs-services py-2" v-else-if="anyEligible && !categoryView && programView">
        <div v-if="programs.filter(x => !x.Ineligible && x.ProgramId == programView).length > 0">
          <p class="large-text text-center">{{screenerContent.ProgramEligible}} {{programs.filter(x => x.ProgramId == programView)[0].Name}}</p>
          <ProgramList :programs="programs.filter(x => !x.Ineligible && x.ProgramId == programView)" :learnMoreText="screenerContent.LearnMoreButton"></ProgramList>
        </div> 
        <div v-else>
          <p class="large-text text-center">{{screenerContent.ProgramNotEligible}} {{programs.filter(x => x.ProgramId == programView)[0].Name}}</p>
        </div>
        <div v-if="programs.filter(x => !x.Ineligible && x.ProgramId != programView).length > 0">
          <div v-if="programs.filter(x => !x.Ineligible && x.ProgramId != programView).length > 0">
            <p class="large-text text-center" v-html="screenerContent.AlsoEligibleFor"></p>
          <p class="text-center" v-html="screenerContent.LearnMoreDescription"></p>
          <ProgramList :programs="programs.filter(x => !x.Ineligible && x.ProgramId != programView)" :learnMoreText="screenerContent.LearnMoreButton"></ProgramList>
          </div>
        </div>
      </section>
      <section class="programs-services py-2" style="background: white;" v-else-if="!anyEligible">
          <p class="large-text pb-1">
              {{screenerContent.NotEligible}}
          </p>
          <p v-html="screenerContent.NeedMoreHelp">
          </p>
      </section>
      <section style="background:white;" class="programs-services py-3">
        <b-container>
          <b-row>
            <b-col md="12">
              <div v-if="anyEligible">
                <b-button variant="primary" v-if="emailSent == 'False'" @click="emailResults">{{screenerContent.ResultsButton}}</b-button>
                <h2 class="card-title" v-else>
                  {{screenerContent.EmailSent}}
                </h2>
              </div>
            </b-col>
            <b-col md="6">
              <b-button variant="primary" @click="completeAgain">{{screenerContent.CompleteAgainButton}}</b-button>
            </b-col>
            <b-col md="6">
              <b-button variant="danger" @click="startOver">{{screenerContent.StartOverButton}}</b-button>
            </b-col>
            <b-col class="mb-4" md="12">
              <p v-html="screenerContent.ResultsDisclaimer">
              </p>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </div>
    <b-modal id="bv-modal-only-nv-address" hide-footer centered>
        <template #modal-title>{{screenerContent.Address.OnlyNevadaTitle}}</template>
        <div class="d-block" v-html="screenerContent.Address.OnlyNevadaContent">
        </div>
        <b-button
          class="mt-3"
          block
          @click="$bvModal.hide('bv-modal-only-nv-address')"
          variant="success"
          >OK</b-button
        >
      </b-modal>
  </b-container>
</template>

<script>
import VueAutoComplete from "vue-google-autocomplete";
import CurrencyInput from "./CurrencyInput.vue";
import ProgramList from './ProgramList.vue';
export default {
  components: { "vue-google-autocomplete": VueAutoComplete, CurrencyInput, ProgramList },
  data() {
    return {
      showHelpText: false,
      helpText: "",
      leadId: null,
      previousComplete: false,
      categoryView: null,
      programView: null,
      programs: [],
      criteria: [],
      selectedCriteria: [],
      showScreener: true,
      anyEligible: false,
      isFourOrFive: false,
      emailSent: "False",
      name: "",
      email: "",
      phone: "",
      hearSelected: "",
      currencyOptions: {
        locale: undefined,
        currency: 'USD',
        currencyDisplay: 'symbol',
        valueRange: undefined,
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        exportValueAsInteger: false,
        autoSign: true,
        useGrouping: true
      },
      hearOther: "",
      address: "",
      addressString: "",
      addressInvalid: false,
      apartment: "",
      addressCounty: "",
      birthday: new Date(),
      current_step: 1,
      max_step: 5,
      birthdayMonth: null,
      birthdayYear: null,
      birthdayDay: null,
      invalidBirthDate: false,
      peopleInHousehold: 0,
      people_in_house_options: ["2", "3", "4", "5", "6", "7", "8"],
      income: 0.0,
      birthday_days: [
        { text: "Day", value: null },
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4", value: "4" },
        { text: "5", value: "5" },
        { text: "6", value: "6" },
        { text: "7", value: "7" },
        { text: "8", value: "8" },
        { text: "9", value: "9" },
        { text: "10", value: "10" },
        { text: "11", value: "11" },
        { text: "12", value: "12" },
        { text: "13", value: "13" },
        { text: "14", value: "14" },
        { text: "15", value: "15" },
        { text: "16", value: "16" },
        { text: "17", value: "17" },
        { text: "18", value: "18" },
        { text: "19", value: "19" },
        { text: "20", value: "20" },
        { text: "21", value: "21" },
        { text: "22", value: "22" },
        { text: "23", value: "23" },
        { text: "24", value: "24" },
        { text: "25", value: "25" },
        { text: "26", value: "26" },
        { text: "27", value: "27" },
        { text: "28", value: "28" },
        { text: "29", value: "29" },
        { text: "30", value: "30" },
        { text: "31", value: "31" },
      ],
      screenerCulture: "",
      screenerContent: null,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      }
    };
  },
  mounted: function () {
    //add an if to check if query string contains category, if so call getcriteriabycategory and pass the category
    //if query string contains program, call getcriteriabyprogram and pass the program
    //otherwise return all

    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);

    this.categoryView = params.get("category");
    this.programView = params.get("program");
    this.leadId = params.get("lead");

    if(localStorage.getItem("name") != null){
      this.name = localStorage.getItem("name");
    }

    if(localStorage.getItem("email") != null){
      this.email = localStorage.getItem("email");
    }

    if(localStorage.getItem("hearSelected") != null){
      this.hearSelected = localStorage.getItem("hearSelected");
    }

    if(localStorage.getItem("hearOther") != null){
      this.hearOther = localStorage.getItem("hearOther");
    }

    if(localStorage.getItem("phone") != null){
      this.phone = localStorage.getItem("phone");
    }

    if(localStorage.getItem("address") != null){
          this.address = JSON.parse(localStorage.getItem("address"));
    }

    if(localStorage.getItem("apartment") != null){
      this.apartment = localStorage.getItem("apartment");
    }

    if(localStorage.getItem("birthdayDay") != null){
      this.birthdayDay = localStorage.getItem("birthdayDay");
    }

    if(localStorage.getItem("birthdayMonth") != null){
      this.birthdayMonth = localStorage.getItem("birthdayMonth");
    }

    if(localStorage.getItem("birthdayYear") != null){
      this.birthdayYear = localStorage.getItem("birthdayYear");
    }

    if(localStorage.getItem("selectedCriteria") != null){
      this.selectedCriteria = JSON.parse(localStorage.getItem("selectedCriteria"));
    }

    if(localStorage.getItem("peopleInHousehold") != null){
      this.peopleInHousehold = JSON.parse(localStorage.getItem("peopleInHousehold"));
    }

    if(localStorage.getItem("income") != null){
      this.income = JSON.parse(localStorage.getItem("income"));
    }
    else{
      this.income = null;
    }

    if(localStorage.getItem("screenerCulture") != null){
      this.screenerCulture = localStorage.getItem("screenerCulture");
    }
    else{
      this.screenerCulture = "en-US";
    }

    fetch("/umbraco/api/programs/getscreenercontent?cultureCode=" + this.screenerCulture)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        this.screenerContent = data;
      });

    if(this.programView){
      fetch("/umbraco/api/programs/getcriteriabyprogram?id=" + this.programView + "&cultureCode=" + this.screenerCulture)
      .then((response) => response.json())
      .then((data) => (this.criteria = data));
    }
    else{
      fetch("/umbraco/api/programs/getallcriteria?cultureCode=" + this.screenerCulture)
      .then((response) => response.json())
      .then((data) => (this.criteria = data));
    }
    
    
    if(this.leadId && localStorage.getItem("programs") != null){
      this.programs = JSON.parse(localStorage.getItem("programs"));
      this.showScreener = false;
      if(localStorage.getItem("anyEligible") != null){
        this.anyEligible = localStorage.getItem("anyEligible");
      }
    }
    else{
      fetch("/umbraco/api/programs/getallprograms?cultureCode=" + this.screenerCulture)
        .then((response) => response.json())
        .then((data) => (this.programs = data));
    }
    

  },
  computed: {
    progress: function () {
      return Math.round(100 / this.max_step) * this.current_step;
    },
    getSavedAddress: function(){
        //Retrieving address from local storage, refs only works when item is displayed;

        if(this.address){
          var addressString = this.address.street_number + ' ' + this.address.route + ', ' + this.address.locality + ', ' + this.address.administrative_area_level_1 + ' ' + this.address.postal_code;
          return addressString;
        }
        

        return '';
    },
    birthday_years: function() {
      const year = new Date().getFullYear();
      return Array.from({length: year - 2009}, (value, index) => 2010 + index).reverse();
    }
  },
  methods: {
    contactInfoSubmit(event) {
      event.preventDefault();
      localStorage.setItem("email", this.email);
      localStorage.setItem("name", this.name);
      localStorage.setItem("phone", this.phone);
      localStorage.setItem("hearSelected", this.hearSelected);
      localStorage.setItem("hearOther", this.hearOther);
      var lead;
      if(this.leadId){
        lead = {
          "LeadId": this.leadId,
          "ParentName": this.name,
          "Email" : this.email,
          "Phone" : this.phone,
          "ReferralType": this.hearSelected,
          "ReferralNote": this.hearOther
        };
      }
      else{
        lead = {
          "ParentName": this.name,
          "Email" : this.email,
          "Phone" : this.phone,
          "ReferralType": this.hearSelected,
          "ReferralNote": this.hearOther
        };
      }

      

      this.postLead(lead);
      this.$announcer.polite("Contact Information Submitted. New Content Loaded'");
      window.scrollTo(0,0);
      this.current_step++;
    },
    birthdaySubmit(event) {
      event.preventDefault();
      this.invalidBirthDate = false;
      var birthdayDayNew = this.birthdayDay;
      if (this.birthdayDay.length < 2) {
        birthdayDayNew = "0" + this.birthdayDay;
      }
      var birthdayString =
        this.birthdayYear +
        "-" +
        this.birthdayMonth +
        "-" +
        birthdayDayNew +
        "T00:00:00.000Z";
      var birthday = Date.parse(birthdayString);

      //check if valid date
      if (isNaN(birthday)) {
        this.invalidBirthDate = true;
        return false;
      }

      birthday = new Date(birthdayString);

      if (birthday.getUTCMonth() != this.birthdayMonth - 1) {
        this.invalidBirthDate = true;
        return false;
      }

      this.birthday = birthday;
      localStorage.setItem("birthdayMonth", this.birthdayMonth);
      localStorage.setItem("birthdayDay", this.birthdayDay);
      localStorage.setItem("birthdayYear", this.birthdayYear);
      this.checkEligibilityBirthday();
      window.scrollTo(0,0);
      this.$announcer.polite('Birthday Submitted. New Content Loaded');
      this.current_step++;
    },
    addressSubmit: function (event) {
      event.preventDefault();
      if (this.address) {
        var found = true;
        if(this.address.administrative_area_level_1 != "NV"){
          found = false;
        }

        if (found) {
          window.scrollTo(0, 0);
          this.checkEligibilityLocation();
          

          if (this.address) {
            this.addressString = this.address.street_number + ' ' + this.address.route + ', ' + this.address.locality + ', ' + this.address.administrative_area_level_1 + ' ' + this.address.postal_code;
          }
          localStorage.setItem("address",JSON.stringify(this.address));
          localStorage.setItem("apartment", this.apartment);

          var lead;
          if(this.address.administrative_area_level_2){
            this.addressCounty = this.address.administrative_area_level_2;
          }
          else if(this.address.locality == "Carson City"){
            this.addressCounty = "Carson City";
          }
          if(this.leadId){
            lead = {
              "ParentName": this.name,
              "Email" : this.email,
              "Phone" : this.phone,
              "ReferralType": this.hearSelected,
              "ReferralNote": this.hearOther,
              "LeadId": this.leadId,
              "Address": this.addressString,
              "ApartmentNumber": this.apartment,
              "County": this.addressCounty
            };
          }
          else{
            lead = {
              "ParentName": this.name,
              "Email" : this.email,
              "Phone" : this.phone,
              "ReferralType": this.hearSelected,
              "ReferralNote": this.hearOther,
              "Address": this.addressString,
              "ApartmentNumber": this.apartment,
              "County": this.addressCounty
            };
          }

          this.postLead(lead);

          window.scrollTo(0,0);
          this.$announcer.polite('Address Information Submitted. New Content Loaded');
          this.current_step++;
        }
        else {
          this.$bvModal.show('bv-modal-only-nv-address')
        }
          
      } 
      else {
        console.log('address empty');
       // this.invalidAddress = true;
        return false;
      }
    },
    onClickBack: function (event) {
      event.preventDefault();
      window.scrollTo(0,0);
      this.current_step--;
    },
    getAddressData(addressData, placeResultData, id) {
      console.log(id, placeResultData);
      this.address = addressData;
    },
    addressInputChanged: function(){
      this.$announcer.polite("Please select an address using the arrow keys");
    },
    specialCircumstancesSubmit: function(event) {
        event.preventDefault();
        localStorage.setItem("selectedCriteria", JSON.stringify(this.selectedCriteria));
        window.scrollTo(0,0);
        this.current_step++;
    },
    incomeSubmit: function(event) {
        event.preventDefault();
        localStorage.setItem("peopleInHousehold", JSON.stringify(this.peopleInHousehold));
        localStorage.setItem("income", JSON.stringify(this.income));
        window.scrollTo(0,0);
        this.checkEligibilityIncome();
        this.checkEligibilitySpecial();
        this.goToResults();
        this.showScreener = false;
    },
    checkEligibilityBirthday: function(){
        //check birthdays
        var that = this;

        var today = new Date();
        var isPrenatal = false;
        if(that.birthday > today){
          isPrenatal = true;
        }
        console.log(that.programs);
        for(var i = 0; i < that.programs.length; i++){
            that.programs[i].IneligibleAge = false;
            console.log(that.programs[i].Age.AgeOfDate);
            var dateToCheck = new Date(that.programs[i].Age.AgeOfDate);
            var minAge = that.programs[i].Age.MinimumAge;
            var maxAge = that.programs[i].Age.MaximumAge;
            var age = this.ageOnDate(that.birthday, dateToCheck);
            if(!isPrenatal){
              if(minAge <= age && age <= maxAge){
                  that.programs[i].Ineligible = false;
              }
              else{
                  that.programs[i].IneligibleAge = true;
              }
            }
            else{
              if(that.programs[i].Age.IncludesPrenatal){
                that.programs[i].Ineligible = false;
              }
              else{
                that.programs[i].IneligibleAge = true;
              }
            }
            
        }     
    },
    ageOnDate: function(birthday, dateToCheck){
        var checkDate = new Date(dateToCheck);
        var birthDate = new Date(birthday);
        var age = checkDate.getFullYear() - birthDate.getFullYear();
        var m = checkDate.getMonth() - birthDate.getMonth();
        age = age * 12 + m;
        if(checkDate.getMonth() == birthDate.getMonth()){
          if(checkDate.getDate() <= birthDate.getDate()){
            age--;
          }
        }
        return age;
    },
    checkEligibilityLocation: function(){
        var that = this;
        if(that.address){
          var county = null;
          var postal = that.address.postal_code;
          if(that.address.administrative_area_level_2){
            county = that.address.administrative_area_level_2;
          }
          else{
            if(that.address.locality == "Carson City"){
              county = "Carson City";
            }
          }
          for(var i = 0; i < that.programs.length; i++){
            that.programs[i].CountyIneligible = false;
            that.programs[i].ZipIneligible = false;
            if(county){
              if(that.programs[i].Counties && that.programs[i].Counties.length > 0){
                var matchingCounties = that.programs[i].Counties.filter(x => x == county);
                if(matchingCounties.length == 0){
                  that.programs[i].CountyIneligible = true;
                }
              }
            }
            if(postal){
              if(that.programs[i].ZipCodes && that.programs[i].ZipCodes.length > 0){
                var matchingZips = that.programs[i].ZipCodes.filter(x => x == postal);
                if(matchingZips.length == 0){
                  that.programs[i].ZipIneligible = true;
                }
              }
            }

          }
          
        }
    },
    checkEligibilitySpecial: function(){
        var that = this;
        console.log('selectedCriteria', that.selectedCriteria);
        for(var i = 0; i < that.programs.length; i++){
            that.programs[i].IneligibleSpecial = false;
            that.programs[i].OverrideIncome = false;
            
            var totalReq = 0;

            if(that.programs[i].IncomeAsRequired){      
              if(that.programs[i].IneligibleIncome){
                that.programs[i].IneligibleIncome = false;
              }
              else{
                totalReq++;
              }
            }

            for(var j = 0; j < that.programs[i].Criteria.length; j++){
                var criteriaId = that.programs[i].Criteria[j].CriteriaId;
                var criteriaType = that.programs[i].Criteria[j].Type;
                if(that.selectedCriteria.includes(criteriaId)){
                    console.log('criteriaId found', criteriaId);
                    if(criteriaType == "Override Income"){
                        that.programs[i].OverrideIncome = true;
                    }
                    else if(criteriaType == "Required"){
                      totalReq++;
                    }
                }
                else {
                    console.log('program: ', that.programs[i]);
                    console.log('missing id: ' + criteriaId);
                    if(criteriaType == "Required" && that.programs[i].MinimumRequired == 0){
                        that.programs[i].IneligibleSpecial = true;
                    }

                    if(criteriaType == "Absolute"){
                      that.programs[i].IneligibleSpecial = true;
                    }
                }
            }

            if(that.programs[i].MinimumRequired > 0 && that.programs[i].MinimumRequired > totalReq){
              console.log('minimum required not met for: ', that.programs[i]);
              console.log('total required: ', totalReq);
              that.programs[i].IneligibleSpecial = true;
            }
        }
    },
    checkEligibilityIncome: function(){
        var that = this;
        for(var i = 0; i < that.programs.length; i++){
            that.programs[i].IneligibleIncome = false;
            
            var income = that.programs[i].Incomes.filter(function(j){
                return j.PeopleInHousehold == that.peopleInHousehold;
            });
            if(income.length > 0){
              if(that.income > income[0].MaximumIncome){
                  that.programs[i].IneligibleIncome = true;
              }
            }
            
        }
    },
    goToResults: function(){
        //Final eligibilty check before showing the results
        var that = this;
        var eligibleList = '';

        console.log(that.programs);
        console.log(that.selectedCriteria);

        for(var i = 0; i < that.programs.length; i++){
            if(that.programs[i].CountyIneligible || that.programs[i].ZipIneligible || that.programs[i].IneligibleAge || 
                          that.programs[i].IneligibleSpecial || (that.programs[i].IneligibleIncome && !that.programs[i].OverrideIncome)){
                that.programs[i].Ineligible = true;
            }
            else{
              that.anyEligible = true;
              eligibleList += that.programs[i].ProgramId + '|';
            }
        }

        //this is where we will save the lead to the db and set local storage item for use on results page
        eligibleList = eligibleList.slice(0, -1);
        var lead;
        if(that.leadId){
          lead = {
            "ParentName": that.name,
            "Email" : that.email,
            "Phone" : that.phone,
            "ReferralType": that.hearSelected,
            "ReferralNote": that.hearOther,
            "LeadId": that.leadId,
            "Address": that.addressString,
            "ApartmentNumber": that.apartment,
            "County": that.addressCounty,
            "EligiblePrograms": eligibleList
          };
        }
        else{
          lead = {
            "ParentName": that.name,
            "Email" : that.email,
            "Phone" : that.phone,
            "ReferralType": that.hearSelected,
            "ReferralNote": that.hearOther,
            "Address": that.addressString,
            "ApartmentNumber": that.apartment,
            "County": that.addressCounty,
            "EligiblePrograms": eligibleList
          };
        }

        that.postLead(lead);
        localStorage.setItem("programs", JSON.stringify(that.programs));
        localStorage.setItem("anyEligible", that.anyEligible);
        localStorage.setItem("leadId", that.leadId);
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.set("lead", that.leadId);
        var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
        history.pushState(null, '', newRelativePathQuery);
        this.$announcer.polite('Application submitted. Your results loaded.');
    },
    postLead: function(lead){
      console.log(lead);
      fetch('/umbraco/api/leadapi/postlead',
      {
        method: 'POST',
        headers: 
          {
            'Content-Type': 'application/json'
          },
        body: JSON.stringify(lead)
      })
      .then(response => response.json())
      .then(data =>{
        this.leadId = data;
      });
    },
    emailResults: function(){
      var that = this;
      fetch("/umbraco/api/leadapi/getemail?leadid=" + that.leadId + "&cultureCode=" + that.screenerCulture)
      .then((data) => (that.emailSent = data));
    },
    completeAgain: function() {
      localStorage.removeItem("programs");
      localStorage.removeItem("anyEligible");
      localStorage.removeItem("leadId");
      localStorage.removeItem("birthdayMonth");
      localStorage.removeItem("birthdayDay");
      localStorage.removeItem("birthdayYear");
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      let lead = params.get("lead");
      if(lead){
        params.delete("lead");
        var newRelativePathQuery = window.location.pathname + '?' + params.toString();
        history.pushState(null, '', newRelativePathQuery);
        window.location.reload();
      }
    },
    startOver: function() {
      localStorage.clear();
      if(this.$session.exists('screenerCompleted')){
        this.$session.remove('screenerCompleted');
        this.$session.remove('screenerPrograms');
      }
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      let lead = params.get("lead");
      if(lead){
        params.delete("lead");
        var newRelativePathQuery = window.location.pathname + '?' + params.toString();
        history.pushState(null, '', newRelativePathQuery);
        window.location.reload();
      }
    },
    openInfo: function(value){
      if(value.startsWith('cat_')){
        var catString = value.replace('cat_', '');
        var category = this.screenerContent.Criteria.Criteria.find(x => x.Value == catString)
        if(category){
          this.helpText = category.HelpText;
        this.showHelpText = true;
        }
      }
      else{
        var critString = value.replace('crit_', '');
        var criteria = this.criteria.find(x => x.value == critString);
        if(criteria){
          this.helpText = criteria.HelpText;
          this.showHelpText = true;
        }
      }
    }
  },
};
</script>
